import React, { FC } from 'react'
// types
import { Classes } from 'jss'
// styles
import injectSheet, { Styles } from 'react-jss'
// utils
import cx from 'classnames'

const style: Styles = {
  wrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: -1
  },
  topLeft: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  botRight: {
    position: 'absolute',
    bottom: 0,
    right: 0
  },
  '@media (max-width: 767.98px)': {
    botRight: {
      bottom: -30,
      right: -50
    },
    topLeft: {
      top: -30,
      left: -50
    }
  }
}

interface Props {
  classes: Classes
  className?: string
}

const BackgroundWithFigures: FC<Props> = ({ classes, className = '' }) => (
  <div className={cx(classes.wrapper, className)}>
    <img className={classes.topLeft} src="/assets/images/bg/figure1.png" />
    <img className={classes.botRight} src="/assets/images/bg/figure2.png" />
  </div>
)

export default injectSheet(style)(BackgroundWithFigures)
